// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__orK7R","label":"styles_label__2lGP6"};